import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=033b2d2b&"
import script from "./desktop.vue?vue&type=script&lang=js&"
export * from "./desktop.vue?vue&type=script&lang=js&"
import style0 from "./desktop.vue?vue&type=style&index=0&id=033b2d2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScheduleFilterCities: require('/opt/yamal.ru/src/components/schedule/filter/cities.vue').default,RzPriceCalendar: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/price-calendar/index.vue').default,RzDateCalendarInput: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/date-calendar-input/index.vue').default})
